import { openApi } from '@/api/request'
import { gioTracking } from "@/utilities/tools"

export default {
  getCruiseFilter () {
    const url = '/Rccl.OpenApi/cruise/GetCruiseFilterHomePage'
    return openApi.get(url)
  },
  setCruiseFilter (data) {
    //GetCruiseFilterV2
    return openApi.get('/Rccl.OpenApi/Cruise/GetCruiseFilterV2', {
      params: {
        shipCode: data.shipCode,
        sailDate: data.sailDate,
        sailDays: data.sailDays,
        departureCodes: data.departureCodes,
        destinationCodes: data.destinationCodes,
        tags: data.tags,
        cruiseSearchType: data.cruiseSearchType
      }
    })
  },
  setCruiseFilterRow (data) {
    // '/Rccl.OpenApi/Cruise/GetCruiseFilter'
    return openApi.get('/Rccl.OpenApi/Cruise/GetCruiseFilterV2', {
      params: {
        shipCode: data.shipCode,
        sailDate: data.sailDate,
        sailDays: data.sailDays,
        departureCodes: data.departureCodes,
        destinationCodes: data.destinationCodes,
        tags: data.tags,
        tripMode:data.tripMode,
        cruiseSearchType: 2,
      }
    })
  },
  cruiseSearch (data,isRow = false) {
    let hotTags = '';
    if (data.tags) {
      hotTags += data.tags;
    }
    if (data.keywords) {
      hotTags += data.tags ? `,${data.keywords}` : data.keywords;
    }
    gioTracking('track', 'evt_Filter', {
      port:data.departureCodes || 'nil',
      departureDate:data.sailDate || 'nil',
      shipCode:data.shipCode || 'nil',
      destination:data.destinationCodes || 'nil',
      sailingNight:data.sailDays || 'nil',
      hotTags: hotTags || 'nil'
    })
    return openApi.get('/Rccl.OpenApi/Cruise/CruiseSearchApi', {
      params: {
        isRow,
        shipCodes: data.shipCode,
        sailDates: data.sailDate,
        sailDays: data.sailDays,
        departureCodes: data.departureCodes,
        destinationCodes: data.destinationCodes,
        tags: data.tags,
        keywords: data.keywords || '',
        cruiseSearchType: data.cruiseSearchType,
        username: data.username,
        tagSource: 'mobile',
        offset: data.offset || 0,
        limit: data.limit || 10,
        isAgency: false,
        orderBysailDate: data.orderBysailDate,
        orderByPrice: data.orderByPrice,
        orderBySailDays: data.orderBySailDays,
        orderByAmountPerNight: data.orderByAmountPerNight,
        tikTokCode: data.tikTokCode,
        tripMode: data.tripMode,
      }
    })
  },
  getCruiseByRoute (routeCode,isRow = false) {
    return openApi.post('/Rccl.OpenApi/Cruise/GetCruiseByrouteCode', {routeCode, isRow})
  },
  getCruiseSearchPage (isRow = false) {
    return openApi.post('/Rccl.OpenApi/Cruise/GetCruiseSearchView',{
      isRow,
      tagSource:'mobile'
    })
  },
  addWishList (requestData) {
    return openApi.post('/Rccl.OpenApi/Cruise/AddCruiseWishList', requestData)
  },
  deleteWishList (requestData) {
    return openApi.post('/Rccl.OpenApi/Cruise/DeleteCruiseWishList', requestData)
  },
  getWishList (requestData) {
    return openApi.post('/Rccl.OpenApi/Cruise/GetAll', requestData)
  },
  getMaxAdultAndChildCount (requestData) {
    return openApi.post('/Rccl.OpenApi/StateroomRecommendation/GetMaxAdultAndChildCount', requestData)
  },
  getRecommendedRoomsByGuestCount (requestData) {
    return openApi.post('/Rccl.OpenApi/StateroomRecommendation/GetRecommendedRoomsByGuestCount', requestData)
  },
  isInWishList (requestData) {
    return openApi.post('/Rccl.OpenApi/Cruise/IsInWishListHP', requestData)
  },
  getCruiseDetail (requestData) {
    return openApi.get('/Rccl.OpenApi/Cruise/GetCruiseDetailHP', {
      params: requestData
    })
  },
  getStateroomCategory (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/GetAllStateroomCategoryApiHP', requestData)
  },
  getShorexByCity (requestData) {
    return openApi.get('/Rccl.OpenApi/Cruise/GetShorexIntroByCity', {
      params: requestData
    })
  },
  getCruiseReview(requestData) {
    return openApi.post('/Rccl.OpenApi/TUITravel/GetReviews', requestData)
  },
  getAllCruiseFeature() {
    return openApi.post('/Rccl.OpenApi/Cruise/GetAllCruiseFeature')
  },
  getBookingPolicyContentList(params, userName) {
    return openApi.post(`/Rccl.OpenApi/Cruise/GetBookingPolicyContentList?${params}`, { userName })
  },
  getShipVrMiniSiteApi(requestData){
    return openApi.get('/Rccl.OpenApi/PanoramicVR/GetPanoramicVRApi', {
      params:requestData
    })
  },
  getCruiseBannerApi(data) {
    return openApi.get('/Rccl.OpenApi/Cruise/CruiseBannerApi',{
      params:{
        businessType:data.businessType
      }
    })
  },
  getOutOfStockInfo(requestData) {
    return openApi.post('/Rccl.OpenApi/OutOfStockApi/SearchOutOfStock', requestData)
  },
  submitOutOfStock(requestData) {
    return openApi.post('/Rccl.OpenApi/OutOfStockApi/SubmitOutOfStock', requestData)
  }
}
